export default __webpack_public_path__ + "assets/images/a727f29229b4fe27c323320d33ae6ad4.png";